import { Icon, mergeStyleSets, useTheme } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";

export interface Props {
  locationName: string;
}

const LocationLabel: FunctionComponent<Props> = (props: Props) => {
  const { locationName } = props;
  const theme = useTheme();
  const classNames = mergeStyleSets({
    headerLabel: {
      padding: 5,
      display: "flex",
      cursor: "pointer",
    },
    headerIcon: {
      flex: 1,
    },
    locationName: [
      theme.fonts.smallPlus,
      {
        flex: 10,
        paddingLeft: 10,
        fontWeight: "bold",
        margin: "auto",
      },
    ],
  });

  return (
    <div className={classNames.headerLabel}>
      <div className={classNames.headerIcon}>
        <Icon iconName="CityNext" style={{ fontSize: 24, color: "#AEAEAE" }} />
      </div>
      <div className={classNames.locationName}>{locationName}</div>
    </div>
  );
};

export default LocationLabel;
